export default __webpack_public_path__ + "static/media/widget_watchbox_vpmndx60_buy.b9086bee.mp3";